// Public conversion destinations, never Google Ads API credentials.
export const GOOGLE_ADS_TAG_ID = "AW-18050981111";
export const GOOGLE_ADS_PURCHASE = `${GOOGLE_ADS_TAG_ID}/EOj5CNX4q60dEPe5sJ9D`;
export const GOOGLE_ADS_CHECKOUT = `${GOOGLE_ADS_TAG_ID}/VvGpCNj4q60dEPe5sJ9D`;
export const GOOGLE_ADS_FRAME_PATH = "/google-ads/";
export const GOOGLE_ADS_URL_PARAMETERS = ["gclid", "gbraid", "wbraid", "gad_source", "gad_campaignid"] as const;

/** Google appends aggregate source/campaign IDs alongside click IDs. Keep the
 * same bounded allowlist at the public-page and isolated-frame boundaries. */
export function validGoogleAdsUrlParameter(key: string, value: string): boolean {
  if (key === "gad_source") return /^[0-9]{1,3}$/.test(value);
  if (key === "gad_campaignid") return /^[0-9]{1,20}$/.test(value);
  return ["gclid", "gbraid", "wbraid"].includes(key) && /^[a-zA-Z0-9_.~-]{1,500}$/.test(value);
}

export type GooglePurchaseReceipt = { eventId: string; value: number; currency: string };
export function validGoogleReceipt(value: unknown): value is GooglePurchaseReceipt {
  const receipt = value as Partial<GooglePurchaseReceipt> | null;
  return !!receipt && typeof receipt.eventId === "string" && /^crimp_purchase_[a-f0-9]{64}$/.test(receipt.eventId) &&
    typeof receipt.value === "number" && Number.isFinite(receipt.value) && receipt.value > 0 &&
    typeof receipt.currency === "string" && /^[A-Z]{3}$/.test(receipt.currency);
}
